/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

  var logo_sliders = document.querySelectorAll('.logo-container .logo-slider');

  if(logo_sliders) {
    logo_sliders.forEach((logo_slider) => {
      const in_sidebar = logo_slider.closest('.content-sidebar-container');

      var slider;

      if(in_sidebar) {
        slider = new Splide(logo_slider, {
          type: 'slide',
          arrows: 'slider',
          pagination: false,
          perPage: 3,
          padding: { top: 1, right: 1, bottom: 1, left: 1 },
          breakpoints: {
            1190: {
              perPage: 2,
            },
            1030: {
              perPage: 5
            },
            900: {
              perPage: 4
            },
            750: {
              perPage: 3
            },
            500: {
              perPage: 2
            }
          }
        });
      } else {
        slider = new Splide(logo_slider, {
          type: 'slide',
          arrows: 'slider',
          pagination: false,
          perPage: 5,
          breakpoints: {
            900: {
              perPage: 4
            },
            750: {
              perPage: 3
            },
            500: {
              perPage: 2
            }
          }
        });
      }

      // $('.carousel-slider').slick({
      //   adaptiveHeight: true,
      //   prevArrow: '<span class="slick-prev slick-arrow"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      //   nextArrow: '<span class="slick-next slick-arrow"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#banner-arrow"></use></svg></span>',
      // });

      slider.mount({ TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag });
    });
  }
}());
